<script lang="ts">
  import type { IUpdateRating } from 'src/lib/interfaces/request-update-rating-question.interface';
  import { state_conversationResults } from '../../store/state';
  import { state_sessionStorage } from '../../store/state';
  import { RatingTypes } from '../../enums/question-rating.enum';
  import { WindowsCustomEventTypes } from '../../enums/windows-custom-event.enum';
  import { ConfigStore } from '../../store/config';
  import { _ } from 'svelte-i18n';

  export let questionId: string;

  const getCsatIconUrl = (filename: string): string => {
    const baseUrl = $ConfigStore.assetBaseUrl || $ConfigStore.apiBaseUrl;

    return `${baseUrl || '.'}/images/csat/${filename}`;
  };

  // Rating options list
  const ratingList = [
    {
      id: 1,
      label: $_('csat.very_dissatisfied'),
      icon: getCsatIconUrl('very-dissatisfied.svg'),
    },
    {
      id: 2,
      label: $_('csat.dissatisfied'),
      icon: getCsatIconUrl('dissatisfied.svg'),
    },
    {
      id: 3,
      label: $_('csat.neutral'),
      icon: getCsatIconUrl('neutral.svg'),
    },
    {
      id: 4,
      label: $_('csat.satisfied'),
      icon: getCsatIconUrl('satisfied.svg'),
    },
    {
      id: 5,
      label: $_('csat.very_satisfied'),
      icon: getCsatIconUrl('very-satisfied.svg'),
    },
  ];
  let timeoutRating: any;

  const sendRating = (val: any) => {
    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.showCsatPopup, {
        detail: {
          isRated: true,
          isNotification: true,
          lengthOfQuestions: $state_conversationResults.length,
        },
      })
    );

    // Off notification after rating and update rating
    timeoutRating = setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.showCsatPopup, {
          detail: {
            ...$state_sessionStorage?.csatRating,
            isNotification: false,
          },
        })
      );
      timeoutRating && clearTimeout(timeoutRating);
    }, $ConfigStore.csatResponseTime);

    // Update api rating

    const data: IUpdateRating = {
      score: val,
      type: RatingTypes.csat,
      questionId,
    };

    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.updateRating, {
        detail: data,
      })
    );
  };

  window.removeEventListener(WindowsCustomEventTypes.showCsatPopup, sendRating);
  window.removeEventListener(WindowsCustomEventTypes.updateRating, sendRating);
</script>

<div role="group" aria-label={$_('csat.title_question')}>
  <ul class="cs-rating-csat__rating">
    {#each ratingList as rating}
      <li>
        <button
          type="button"
          on:click={() => sendRating(rating.id)}
          on:keydown={(e) => e.key === 'Enter' && sendRating(rating.id)}
          aria-label={rating.label}
          title={rating.label}
        >
          <div class="cs-rating-csat__rating-wrapper">
            <img
              class="cs-rating-csat__icon"
              src={rating.icon}
              alt={rating.label}
            />
          </div>
        </button>
      </li>
    {/each}
  </ul>
</div>
<div class="cs-rating-csat__rating">
  <div class="cs-rating-csat__rating-wrapper">
    <span aria-hidden="true">
      {$_('csat.very_dissatisfied')}
    </span>
  </div>
  <div class="cs-rating-csat__rating-wrapper">
    <span aria-hidden="true">
      {$_('csat.dissatisfied')}
    </span>
  </div>
  <div class="cs-rating-csat__rating-wrapper">
    <span aria-hidden="true">
      {$_('csat.neutral')}
    </span>
  </div>
  <div class="cs-rating-csat__rating-wrapper">
    <span aria-hidden="true">
      {$_('csat.satisfied')}
    </span>
  </div>
  <div class="cs-rating-csat__rating-wrapper">
    <span aria-hidden="true">
      {$_('csat.very_satisfied')}
    </span>
  </div>
</div>

<style lang="scss">
  @use './../../../scss/components/_rating-csat-one';
</style>
